import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { invoiceNumberValidator } from '../validators/invoice-validators';

export type DynamicFormControlType =
  | 'text'
  | 'number'
  | 'multiline'
  | 'file'
  | 'turnstile';

export interface DumbControlConfiguration {
  type: DynamicFormControlType;
  section?: string;
  name: string;
  displayName?: string;
  reqiuired?: boolean;
}

export interface TableControlConfiguration {
  type: 'table';
  section?: string;
  name: string;
  displayName?: string;
  columns: DumbControlConfiguration[];
}

export interface InvoiceControlConfiguration {
  type: 'invoice';
  section?: string;
  name: string;
  displayName?: string;
  reqiuired?: boolean;
}

export type DynamicControlConfiguration =
  | DumbControlConfiguration
  | TableControlConfiguration
  | InvoiceControlConfiguration;

export interface DynamicFormConfiguration {
  controls: DynamicControlConfiguration[];
}

export class DynamicFormControl {
  constructor(public config: DynamicControlConfiguration) {}

  toNgFormControl(): { name: string; formControl: AbstractControl } {
    switch (this.config.type) {
      case 'table':
        return this.getTableNgFormControl(this.config);
      case 'invoice':
        return this.getInvoiceNgFormControl(
          this.config as InvoiceControlConfiguration
        );
      default:
        return this.getDumbNgFormControl(this.config);
    }
  }

  getTableNgFormControl(config: TableControlConfiguration): {
    name: string;
    formControl: FormArray<FormGroup>;
  } {
    const defaultFormGroup = new FormGroup({});

    config.columns.forEach((column) => {
      const { name, formControl } = this.getDumbNgFormControl(column);
      defaultFormGroup.addControl(name, formControl);
    });

    const formArray = new FormArray<FormGroup>([defaultFormGroup]);
    return { name: config.name, formControl: formArray };
  }

  getInvoiceNgFormControl(config: InvoiceControlConfiguration): {
    name: string;
    formControl: FormControl<any>;
  } {
    const validators = [];
    if (config.reqiuired) {
      validators.push(Validators.required);
    }
    validators.push(invoiceNumberValidator());

    return {
      name: config.name,
      formControl: new FormControl(null, validators),
    };
  }

  getDumbNgFormControl(config: DumbControlConfiguration): {
    name: string;
    formControl: FormControl<any>;
  } {
    const validators = [];
    if (config.reqiuired) {
      validators.push(Validators.required);
    }

    const defaultValue = config.type === 'file' ? [] : null;
    return {
      name: config.name,
      formControl: new FormControl(defaultValue, validators),
    };
  }
}
